/**
 * The hotel's voice line as the backend sends it ("+" and E.164 digits, e.g.
 * "+390273103707"), turned into what the "call us" card needs: a `tel:` href
 * and a number a guest can read off a desktop screen and dial by hand.
 */

/** Digits only, or null when there is nothing a phone could dial. */
export const dialableDigits = (raw?: string | null): string | null => {
  const digits = (raw ?? "").replace(/\D/g, "");
  return digits.length >= 6 ? digits : null;
};

export const telHref = (digits: string) => `tel:+${digits}`;

const group = (digits: string, sizes: number[]) => {
  const parts: string[] = [];
  let rest = digits;
  for (const size of sizes) {
    if (rest.length <= size) break;
    parts.push(rest.slice(0, size));
    rest = rest.slice(size);
  }
  parts.push(rest);
  return parts.join(" ");
};

/**
 * Italian numbers get the grouping Italians write: mobiles 3-3-4
 * ("+39 351 234 5678"), Milan and Rome landlines 2-4-4 ("+39 02 7310 3707").
 * Other Italian landlines keep the national part whole, because the area code
 * length (3 or 4 digits) cannot be told from the digits alone and a wrong
 * split is worse than none. Foreign numbers keep the digits as they are.
 */
export const displayNumber = (digits: string): string => {
  if (!digits.startsWith("39")) return `+${digits}`;

  const national = digits.slice(2);

  if (national.startsWith("3")) return `+39 ${group(national, [3, 3])}`;
  if (national.startsWith("02") || national.startsWith("06"))
    return `+39 ${group(national, [2, 4])}`;

  return `+39 ${national}`;
};
